import '@/polyfills';
import 'resize-observer-polyfill';
import Vue from 'vue';
import store from '@/store';
import App from './App.vue';
import router from '@/router';
import i18n, { commonCacheLanguage } from 'common-module/src/lang';
import { createPinia, PiniaVuePlugin } from 'pinia';

import '@/styles/index.scss'; // global css
import '@zk/theme/dist/index.css';
// 主题包没有打包css文件
import '@zk/theme/lib/var-index.scss';

                 
import '@zk/theme/dist/font-en.css';
        
                                    
         
import { useNoPermissionAlert } from '@/components/NoPermissionAlert';
import { reloadI18n } from 'common-module/src/util';
import 'common-module/src/directive';

Vue.use(PiniaVuePlugin);
Vue.config.productionTip = false;
Vue.config.performance = true;
// 安装插件
// @ts-ignore
const commonPlugins = require.context('common-module/src/plugins', true, /^(?!.*-(en|zh)\.(j|t)s).*\.(j|t)s$/);
commonPlugins.keys().forEach(commonPlugins);
// @ts-ignore
const plugins = require.context('@/plugins', true, /^(?!.*-(en|zh)\.(j|t)s).*\.(j|t)s$/);
plugins.keys().forEach(plugins);

Vue.i18n = i18n;

const tryReloadI18n = async (maxCount = 3, count = 0) => {
  try {
    // 异步加载语言包，防止使用上次缓存（缓存的目的是加快进入系统）
    await reloadI18n(i18n.locale);
    commonCacheLanguage.loadLanguages(undefined, true);
  } catch (e) {
    if (count >= maxCount) {
      window.console.error('reload i18n error', e);
      return;
    }
    setTimeout(() => tryReloadI18n(maxCount, ++count), 1500);
  }
};

// store.dispatch('app/updateMenu')
commonCacheLanguage.loadLanguages().then(() => {
  const vue = new Vue({
    i18n,
    router: router as any,
    store,
    pinia: createPinia(),
    async created() {
      tryReloadI18n();
    },
    mounted() {
      vue.master = true;
    },
    render: h => h(App)
  });
  useNoPermissionAlert(vue);
  console.log('start mount');
  const mount = () => vue.$mount('#app');
  // 这里mount的时间提前可以让vue提前加载，不过有两个问题：
  // 1、目前绑定在router中的几个接口和视图存在强依赖关系
  // 2、经多次测试，提前mount并不会提升lcp指标，反而还会下降
  router.onReady(mount, mount);
});
window.__BASE_URL_BY_QIANKUN__ = process.env.BASE_URL || '/';
